import { Alert, Box, CircularProgress } from "@mui/material";
import React, { useRef } from "react";
import { useFetchChecklist } from "../hooks/useFetchChecklist";
import { CheckList } from "../../../shared/components";
import { FileUploadRef } from "../../../shared/components/FileUpload";

export const CheckListDetails: React.FC<{ stageID: string; refetch: () => void }> = ({ stageID, refetch }) => {

    const fileUploadRef = useRef<FileUploadRef | null>(null);

    const {
        isPending,
        isUpdating,
        isAdding,
        isEditing,
        data,
        handleUpdateCheckList,
        handleEditChecklist
    } = useFetchChecklist(stageID);

    const handleSaveChecklist = async (
        checklistId: string,
    ) => {
        if (fileUploadRef.current) {
            fileUploadRef.current.setId(checklistId);
            setTimeout(() => {
                fileUploadRef.current?.uploadAllFiles();
            }, 0);
        }
    };

    const onSuccess = async (checklistId: string, _isEdit: boolean) => {
        await handleUpdateCheckList(checklistId, 'checklist', Number(stageID));
        refetch();
    };

    if (isPending) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (data.length === 0) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <Alert severity="warning">No checklist assigned</Alert>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" height="100%" sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
            {data.map(
                (stage: {
                    task_id: string;
                    status: "completed" | "in_progress" | "not_started";
                    task_name: string;
                    owner: string;
                    updated_at: string;
                    is_required: boolean;
                    is_evidence_required: boolean;
                }) => (
                    <CheckList
                        key={stage.task_id}
                        completedStatus={stage.status}
                        title={stage.task_name}
                        owner={stage.owner}
                        completedDate={stage.updated_at}
                        downloadLink={"sample link"}
                        isRequired={stage.is_required}
                        isEvidenceRequired={stage.is_evidence_required}
                        isLoading={isAdding || isEditing || isUpdating}
                        fileUploadRef={fileUploadRef}
                        checkListId={stage.task_id}
                        onSave={() => handleSaveChecklist(stage.task_id)}
                        onUploadComplete={( isEdit: boolean) => {
                            if (onSuccess) onSuccess(stage.task_id, isEdit);
                        }}
                        checklistType={"stageGate"}
                    />
            )
            )}
        </Box>
    );
};